import React from "react";
import { StyledSettingsContainer } from "./_components";
import { Box, } from "@material-ui/core";
import { MoonLoader } from "react-spinners";


export const SettingsLoader = () => {
  return (
    <StyledSettingsContainer>
      <Box width="100%" height="70px" display="flex" justifyContent="center" alignItems="center">
        <MoonLoader color='white' size='30px' />
      </Box>
    </StyledSettingsContainer>
  )
}